import {z} from 'zod';

import i18n from '@dms/i18n';

const destinationBranchSchema = z.object({
  branchId: z.string(),
  docSeriesId: z.string(),
  transitTimeDays: z.number().min(0, i18n.t('general.errors.number.greaterOrEqual', {min: 0})),
  isDefault: z.boolean(),
});

export const tireTransitFormSchema = z.object({
  homeBranchId: z.string(),
  destinationBranch: z
    .array(destinationBranchSchema)
    .min(1, i18n.t('general.notifications.errorFieldRequired')),
});

export type TireTransitFormType = z.infer<typeof tireTransitFormSchema>;
